import { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import useClickOutside from 'hooks/useClickOutside'

import { ReactComponent as IconMagnifier } from 'assets/icons/IconMagnifier.svg'
import { ReactComponent as IconChevron } from 'assets/icons/IconChevron.svg'

const SearchBarWithSelect = ({
  handleSearch,
  options,
  selectedOptionUuid,
  defaultInputValue,
}) => {
  const [inputValue, setInputValue] = useState(defaultInputValue)
  const [dropdownValue, setDropdownValue] = useState(selectedOptionUuid)
  const [isDropdownOpen, setDropdownOpen] = useState(false)

  const inputRef = useRef(null)
  const dropdownRef = useRef(null)
  const buttonRef = useRef(null)

  useClickOutside(dropdownRef, buttonRef, setDropdownOpen, isDropdownOpen)

  const selectedOption = options?.find(
    (option) => option.uuid === dropdownValue
  )

  const label = selectedOption?.label

  const onChangeInput = (event) => {
    setInputValue(event.target.value)
  }

  const handleClickDropdown = () => {
    setDropdownOpen(!isDropdownOpen)
  }

  const handleClickDropdownOption = (uuid) => {
    setDropdownValue(uuid)
    setDropdownOpen(false)
  }

  const searchValues = {
    searchQuery: inputValue,
    selectedSearchOptionUuid: dropdownValue,
  }

  const handleClickSearch = () => {
    handleSearch(searchValues)
  }

  useEffect(() => {
    const inputRefCurrent = inputRef?.current

    const handleEnterPress = ({ key }) => {
      if (key === 'Enter') {
        handleSearch(searchValues)
      }
    }
    inputRefCurrent.addEventListener('keyup', handleEnterPress)
    return () => {
      inputRefCurrent.removeEventListener('keyup', handleEnterPress)
    }
    //eslint-disable-next-line
  }, [inputValue, dropdownValue])

  return (
    <div className="search-bar">
      <input
        className="search-bar__input"
        placeholder="Search"
        type="text"
        value={inputValue}
        onChange={onChangeInput}
        ref={inputRef}
      />
      <div className="search-bar__dropdown">
        <span
          onClick={handleClickDropdown}
          role="button"
          className="search-bar__dropdown-selected-item"
          ref={buttonRef}
        >
          {label}
          <IconChevron className="search-bar__dropdown-icon" />
        </span>
        {isDropdownOpen && (
          <ul ref={dropdownRef} className="search-bar__dropdown-list">
            {options?.map(({ uuid, label }) => (
              <li
                onClick={() => {
                  handleClickDropdownOption(uuid)
                }}
                role="button"
                id={uuid}
                key={uuid}
                className="search-bar__dropdown-item"
              >
                {label}
              </li>
            ))}
          </ul>
        )}
      </div>
      <button className="search-bar__search-icon" onClick={handleClickSearch}>
        <IconMagnifier />
      </button>
    </div>
  )
}

SearchBarWithSelect.propTypes = {
  handleSearch: PropTypes.func,
  options: PropTypes.array,
  selectedOptionUuid: PropTypes.string,
  defaultInputValue: PropTypes.string,
}

SearchBarWithSelect.defaultProps = {
  handleSearch: () => {},
  options: [],
  selectedOptionUuid: '',
  defaultInputValue: '',
}

export default SearchBarWithSelect
